"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContentTypeSystemAttributes = /** @class */ (function () {
    function ContentTypeSystemAttributes(data) {
        Object.assign(this, data);
    }
    return ContentTypeSystemAttributes;
}());
exports.ContentTypeSystemAttributes = ContentTypeSystemAttributes;
var ContentType = /** @class */ (function () {
    function ContentType(data) {
        Object.assign(this, data);
    }
    return ContentType;
}());
exports.ContentType = ContentType;
//# sourceMappingURL=content-type-models.js.map